import { promoteAnchorParam } from '@app/utils/url-helpers'

// Promotion has to land before anything reads `window.location.hash`, which
// means before every Vue mount and Stimulus connect on the page. Those all run
// from `turbolinks:load` handlers, and `turbolinks:before-render` fires ahead
// of them with the URL already updated (Turbolinks changes history when the
// visit starts, before any render) -- so the promoted fragment is in place
// before any reader looks, regardless of when this setup runs.
//
// The immediate call covers full page loads, where before-render never fires;
// there the whole entry evaluates before the first turbolinks:load anyway.
// promoteAnchorParam() is a no-op without an `_anchor` param, so the visits
// that fire before-render more than once (cached-snapshot previews) are fine.
export const setupPromoteAnchorParam = (): (() => void) => {
  promoteAnchorParam()

  document.addEventListener('turbolinks:before-render', promoteAnchorParam)

  return () => {
    document.removeEventListener('turbolinks:before-render', promoteAnchorParam)
  }
}
